import Image from 'next/image'

export function Logo() {
  return <Image src="/img/Stogo-Logo.svg" alt="logo" width={40} height={40} unoptimized />
}
